"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyMessageActionOperation_1 = require("owa-service/lib/operation/applyMessageActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
var applyMessageActionRequest_1 = require("owa-service/lib/factory/applyMessageActionRequest");
var messageAction_1 = require("owa-service/lib/factory/messageAction");
var itemId_1 = require("owa-service/lib/factory/itemId");
/**
 * Restore item service
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage
 */
function restoreItemService(itemIds) {
    var requestBody = configureRequestBody(itemIds);
    return applyMessageActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = restoreItemService;
/**
 * Configure the request body
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage body
 */
function configureRequestBody(itemIds) {
    return applyMessageActionRequest_1.default({
        MessageAction: messageAction_1.default({
            Action: 'Restore',
        }),
        Ids: itemIds.map(function (itemIdValue) { return itemId_1.default({ Id: itemIdValue }); }),
    });
}
//# sourceMappingURL=restoreItemService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/restoreItemService.js
// module id = 5581
// module chunks = 62